export var apiVersion = process.env.VUE_APP_SANITY_API_VERSION || "2025-02-01";
export var dataset = process.env.VUE_APP_SANITY_DATASET;
export var projectId = process.env.VUE_APP_SANITY_PROJECT_ID;
export var useCdn = false;
export var perspective = "published";